import type { RaceSelection } from "@/features/betslip/types";
import type { RaceToggleInput } from "@/features/betslip/builders/types";
import { getActualCompetitorId } from "@/features/betslip/utils/selectionHelpers";

export const buildRaceSelection = (input: RaceToggleInput): RaceSelection => {
  const {
    event,
    market,
    outcome,
    outcomeId,
    hub,
    originType,
    originId,
    competitors,
  } = input;

  // Racing competitors live in a separate firestore subcollection (not
  // on the event), so the call site plumbs the full competitors array
  // through. Look up the runner this bet is on.
  const competitor = outcome.competitorId
    ? competitors.find((c) => c.id === outcome.competitorId)
    : undefined;

  // SRM-availability gating uses the race timezone and the server's
  // semAvailableAtTs (stamped on the racing event).
  const semAvailableAtMs = event.semAvailableAtTs?.toMillis();

  return {
    kind: "race",
    outcomeId,
    eventId: event.id,
    marketId: market.id,
    selectionName: outcome.name ?? "",
    eventName: event.eventName ?? "",
    marketName: market.name ?? "",
    sport: event.sport ?? "",
    startTime: market.nextBetStop ?? event.scheduledStartTime ?? new Date(),
    hub,
    marketType: market.marketType ?? "",
    odds: outcome.odds ?? 0,
    isSP: market.marketType?.endsWith("_SP"),
    isMultiable: market.attributes?.multiable ?? true,
    independentPerEvent: market.independentPerEvent ?? false,
    filters: event.filters ?? [],
    blockPromotionsBets: !!market.blockPromotionsBets,
    hasPromotionalMarkets: !!market.hasPromotionalMarkets,
    hasLiveMarkets: false,
    originType: originType ?? "BETTING",
    originId,
    competitor,
    competitorId: getActualCompetitorId(outcome),
    outcomeGroup: outcome.outcomeGroup,
    silksUrl: event.silksUrl,
    expectedResults: event.expectedResults,
    marketStatus: market.status,
    eventStatus: event.status,
    timezone: input.timezone,
    semAvailableAtMs,
    meetingId: event.meetingId,
    region: event.region,
  };
};
